// extracted by mini-css-extract-plugin
module.exports = {"MainArea":"main-area_MainArea__wSZ_p"};